import VueCookies from 'vue-cookies';
import { authService } from '../../network';
import {
  FETCH_AUTH,
  SET_PROFILE,
  UNSET_PROFILE,
  LOG_OUT,
  LOG_IN,
  GET_LOGGED_USER,
  TOKEN_VALIDATION,
  REFRESH_TOKEN,
  RESET_PASS,
  SELECTS,
  ACTION_SELECTED_SUBHOLDING,
} from '../types';

const store = {};
const getDefaultState = () => ({
  auth: {
    id: '',
    email: '',
    name: '',
    phone: '',
    roleName: '',
    roleId: '',
    tokenExpirationDate: ''
  },
  loading: false,
});

store.state = getDefaultState();

store.getters = {
  [GET_LOGGED_USER](state) {
    return state.auth;
  },
};

store.mutations = {
  [SET_PROFILE](state, payload) {
    state.auth.id = payload.id;
    state.auth.email = payload.email;
    state.auth.name = payload.name;
    state.auth.phone = payload.phone;
    state.auth.roleName = payload.role.tag;
    state.auth.roleId = payload.role.id;
    state.auth.tokenExpirationDate = payload.exp_token_date;
  },
  [UNSET_PROFILE](state) {
    state.auth.id = '';
    state.auth.email = '';
    state.auth.name = '';
    state.auth.phone = '';
    state.auth.roleName = '';
    state.auth.roleId = '';
    state.auth.tokenExpirationDate = '';
  },
};

store.actions = {
  async [FETCH_AUTH]({ commit }, payload) {
    commit(SET_PROFILE, payload);
  },
  [LOG_OUT]({ commit }) {
    return new Promise((resolve, reject) => {
      authService.deleteTokens()
        .then((resp) => {
          commit(UNSET_PROFILE);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [LOG_IN]({ commit }, payload) {
    return new Promise((resolve, reject) => {
      authService.authLogin(payload).then(
        (resp) => {
          commit(SET_PROFILE, resp.data.body);
          resolve(resp);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },
  [REFRESH_TOKEN]() {
    return new Promise((resolve, reject) => {
      authService.tokenRefresh()
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [TOKEN_VALIDATION]() {
    return new Promise((resolve, reject) => {
      authService.tokenValidation()
        .then((resp) => {
          resolve(resp.data.body);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [LOG_OUT]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      authService.deleteTokens()
        .then((resp) => {
          commit(UNSET_PROFILE);
          VueCookies.remove('busqueda');
          setTimeout(() => {
            dispatch(SELECTS, []);
            dispatch(ACTION_SELECTED_SUBHOLDING, []);
          }, 3000);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [RESET_PASS]({ commit }, payload) {
    return new Promise((resolve, reject) => {
      authService.resetMail(payload).then(
        (resp) => {
          // Clear profile as the user is no longer authenticated during reset flow
          commit(UNSET_PROFILE);
          resolve(resp);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  
};

export default store;
